import { RouteConfig } from 'vue-router';

export const resendConfirmRoute: RouteConfig = {
  name: 'resendConfirm',
  path: '/resend',
  component: () => import(/* webpackChunkName: "ResendConfirm" */ '@/views/confirm/ResendConfirm.vue')
};
